import communityWalkthrough from '../../modules/community/walkthrough/tso.json';

export const TSO = {
  translation: {
    ...communityWalkthrough,
  },
};
